export default __webpack_public_path__ + "static/media/azure.405665e9.svg";